import React from "react";

type Props = {
  text: string;
};

const SidebarSubHeading: React.FC<Props> = (props) => {
  return (
    <h4 className="mt-6 mb-3 pl-2 pb-3 font-bold text-base bg-[length:8px_2px] bg-repeat-x bg-left-bottom">
      {props.text}
    </h4>
  );
};

export default SidebarSubHeading;
